<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5 9H51C56.799 9 61.5 13.701 61.5 19.5V19.5C61.5 25.299 56.799 30 51 30H19.5C13.701 30 9 25.299 9 19.5V19.5C9 13.701 13.701 9 19.5 9Z"
      stroke="currentColor"
      stroke-width="4.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51 63H19.5C13.701 63 9 58.299 9 52.5V52.5C9 46.701 13.701 42 19.5 42H51C56.799 42 61.5 46.701 61.5 52.5V52.5C61.5 58.299 56.799 63 51 63Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M50.994 51C50.166 51 49.494 51.672 49.5 52.5C49.5 53.328 50.172 54 51 54C51.828 54 52.5 53.328 52.5 52.5C52.5 51.672 51.828 51 50.994 51"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.494 18C18.666 18 17.994 18.672 18 19.5C18 20.328 18.672 21 19.5 21C20.328 21 21 20.328 21 19.5C21 18.672 20.328 18 19.494 18"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
